import { useMutation as r, useQuery as u } from "@tanstack/react-query";
import { aw as s, g as o, h as a, ag as i, aK as c, W as y } from "./services.gen-D7DK4RCL.js";
function q(n) {
  return {
    ...r({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (e) => s(e),
      ...n
    })
  };
}
function A(n) {
  return {
    ...r({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (e) => o(e),
      ...n
    })
  };
}
function m(n) {
  return ["analyticsAnalyticsCreate", n];
}
function l(n, t) {
  return {
    ...u({
      queryKey: m(n),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => a(n),
      ...t
    })
  };
}
function C(n) {
  return ["conversationAdminConversationsRead", n];
}
function g(n, t) {
  return {
    ...u({
      queryKey: C(n),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => i(n),
      ...t
    })
  };
}
function v(n) {
  return ["councilCouncilsList", n];
}
function R(n, t) {
  return {
    ...u({
      queryKey: v(n),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => c(n),
      ...t
    })
  };
}
function K(n) {
  return {
    ...r({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (e) => y(e),
      ...n
    })
  };
}
export {
  A as a,
  l as b,
  C as c,
  g as d,
  v as e,
  R as f,
  m as g,
  K as h,
  q as u
};
//# sourceMappingURL=useReviseConversationExpertResult-D8w2nkRT.js.map
